import { render, staticRenderFns } from "./RibbonBar.vue?vue&type=template&id=365ed282&scoped=true"
import script from "./RibbonBar.vue?vue&type=script&lang=js"
export * from "./RibbonBar.vue?vue&type=script&lang=js"
import style0 from "./RibbonBar.vue?vue&type=style&index=0&id=365ed282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ed282",
  null
  
)

export default component.exports